/* eslint-disable @typescript-eslint/ban-types */

import { IntakeFormQuestionResponseNode } from 'src/generated/webapp_gql';
import {
    AnswerOptionData,
    answersMap,
    questionDataMap,
    questionNamesAsCamel,
    questionsToScreenMap,
    Screens,
} from '../models/intakeForm';

export const getNextScreen = (current: Screens): Screens => {
    const next = Number(current) + 1;

    if (next === Screens.__LENGTH) {
        return current;
    }

    return next;
};

export const getPreviousScreen = (currentScreen: Screens) => {
    if (currentScreen === 1) {
        return currentScreen;
    }

    return currentScreen - 1;
};

export interface SubQuestion {
    subQuestionId: string;
    subQuestionTitle: string;
    subQuestionSubtitle: string;
}

export interface IntakeFormQuestionData {
    questionId?: string;
    questionIds?: SubQuestion[];
    questionText: string;
    screenIndex: number;
    questionPlaceholder?: string;
    answerIds?: string[];
}

export const getQuestionDataFor = (screen: Screens): IntakeFormQuestionData => {
    return (
        questionDataMap[screen] || {
            questionId: '',
            questionText: 'There was an error',
            questionPlaceholder: 'There was an error',
            screenIndex: 0,
        }
    );
};

export const getAnswerOptionData = (answerId: string) => {
    return answersMap[answerId] as AnswerOptionData;
};

type IntakeFormQuestionResponseFragment = Pick<
    IntakeFormQuestionResponseNode,
    'questionName' | 'questionResponseContent'
>;

export const getIntakeFormData = (
    intakeFormQuestionResponses: (IntakeFormQuestionResponseFragment | null)[] | null | undefined,
) => {
    const answerData = {};
    let lastScreen = 0;

    if (!intakeFormQuestionResponses) {
        return { answerData, lastScreen };
    }

    intakeFormQuestionResponses.forEach(response => {
        if (!response) {
            return;
        }

        const { questionName, questionResponseContent } = response;

        if (!questionName) {
            return;
        }

        const currentScreen = questionsToScreenMap[questionName || 0];
        const currentIsSingleQuestion = !!questionDataMap[currentScreen].questionId;

        if (currentIsSingleQuestion) {
            answerData[currentScreen] = questionResponseContent;
        } else {
            answerData[currentScreen] = {
                ...(answerData[currentScreen] || {}),
                [questionName]: questionResponseContent,
            };
        }

        if (!!questionResponseContent) {
            lastScreen = Math.max(lastScreen, currentScreen);
        }
    });

    return { lastScreen, answerData };
};

export const getCamelCaseId = (original: string) => {
    return questionNamesAsCamel[original] || original;
};

export const getBulkCamelForIds = (originalObj: object) => {
    const ret = {};

    Object.entries(originalObj).forEach(([key, value]) => {
        ret[questionNamesAsCamel[key] || key] = value;
    });

    return ret;
};
